import { forwardRef } from 'react';

import { AlertType, alertTypeMapping } from '@/entities/alert-type';
import { cls } from '@/utils/cls';

export type AlertTypeBadgeProps = { type: AlertType; className?: string };

const AlertTypeBadge = forwardRef<HTMLDivElement, AlertTypeBadgeProps>(
  ({ type, className }, ref) => (
    <div
      ref={ref}
      className={cls(
        'inline-block rounded-full border border-gray-200 px-2 py-1 text-xs font-normal leading-none text-gray-800',
        className,
      )}
    >
      {alertTypeMapping[type]}
    </div>
  ),
);

AlertTypeBadge.displayName = 'AlertTypeBadge';
export { AlertTypeBadge };
